import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconPaths } from '../../../../../../../_metronic/helpers'
import { useT } from '../../../../../../../_metronic/i18n/Metronici18n'
import { RowActions } from '../../../../../../components'
import { NotaVersaoUsuarioItem } from '../../../core/_models'

type Props = {
  nota: NotaVersaoUsuarioItem
}

export const NovidadesActionsCell: FC<Props> = ({ nota }) => {
  const { t } = useT()
  const navigate = useNavigate()

  return (
    <RowActions
      itemName={`${nota.titulo}, ${t('notas_versao.versao_x', { versao: nota.versao })}`}
      primaryAction={{
        label: t('notas_versao.historico.abrir'),
        onClick: () => navigate(`/apps/novidades/${nota.id}`),
        icon: IconPaths.Search,
      }}
    />
  )
}
